<template>
    <div style="  background: #eeeeee;height: 100vh;">
        <div class="wrap">
            <div class="walletTop">
                <van-icon name="arrow-left" color="#fff" size="25" @click="$router.go(-1)" />
                <div class="topTitle">
                    <div>
                        累计积分
                    </div>
                </div>
                <div class="topNum">
                    <div>
                        {{balance}}
                    </div>
                    <div>
                        总积分(元)
                    </div>
                </div>
            </div>
            <!-- 列表 -->
            <van-tabs v-model="active" @click='getactive' title-active-color='#3B6BFB'>
                <van-tab title="收入"></van-tab>
                <van-tab title="支出"></van-tab>
            </van-tabs>
            <!-- 列表 -->
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了" class="recordList"
                v-if='list.length>0'>
                <div class="recordItem" v-for="(item,index) in list" :key="index">
                    <div class="itemLeft" style="width: 100%;">
                        <div class="itemMoney" style="font-weight:bold;">
                            {{item.currency_name}}
                        </div>
                        <div class="itemMoney">
                            {{item.bill_type}}
                        </div>
                        <div class="itemMoney">
                            金额:
                            <span v-if='item.type==2' style="color: #3B6BFB;">-</span>
                            <span v-if='item.type==1' style="color: red;">+</span>
                            <span>{{item.account}}</span>
                        </div>
                        <div class="itemMoney"> <span>时间:{{item.create_time}}</span></div>
                    </div>
                </div>
            </van-list>
            <div v-else class="noData">
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { billRecord, billRecordList } from "@/api/personal";
    export default {
        data() {
            return {
                balance: 0,
                list: [],
                active: 0,
                list: [],
                form: {
                    type: 1,
                    page: 1,
                    pagesize: 1
                }
            };
        },
        created() {
            billRecord().then(res => {
                this.balance = res.account;
            })
            this.onLoad();
        },
        methods: {
            getactive(e) {
                this.form.type = e + 1;
                this.form.page = 1;
                this.list = [];
                this.onLoad();
            },
            onLoad() {
                billRecordList(this.form).then(resp => {
                    let rows = resp.data;
                    this.count = resp.count;
                    this.loading = false;
                    this.finished = false;
                    if (rows == null || rows.length == 0) {
                        this.finished = true;
                        return;
                    }
                    this.list = this.list.concat(rows);
                    if (this.list.length >= this.count) {
                        this.finished = true;
                        return;
                    }
                    this.form.page++;
                });
            }
        }
    };
</script>
<style lang='less' scoped>
    .wrap {
        background: #eeeeee;

        .walletTop {
            width: 100%;
            height: 254.5px;
            background: url('../../assets/imgs/personal/bg.png') 0 0 no-repeat;
            background-size: 100% 100%;
            color: #FEFEFE;
            font-size: 18px;
            padding-top: 14.5px;
            box-sizing: border-box;

            .topTitle {
                display: flex;
                margin-bottom: 26.5px;

                div {
                    &:first-child {
                        background: #4FB7FE;
                        font-size: 15px;
                        border-radius: 0px 13.25px 13.25px 0px;
                        margin-right: 9px;
                        height: 26.5px;
                        line-height: 26.5px;
                    }

                }
            }

            .topNum {
                text-align: center;

                div {
                    &:first-child {
                        margin-bottom: 23.5px;
                        font-size: 53px;
                    }
                }
            }
        }

        .recordList {
            width: 345px;
            border-radius: 8px;
            background: #fff;
            box-sizing: border-box;
            padding: 0 13px;
            margin: 10px auto 0;

            .recordItem {
                display: flex;
                justify-content: space-between;
                color: #666666;
                padding: 14.5px 0 12.5px;
                border-bottom: 1px solid #c1c1c1;
                font-size: 13px;

                .itemtype {
                    color: #343434;
                }

                .itemMoney {
                    margin-top: 11.5px;

                    span {
                        color: #343434;
                    }
                }

                .itemRight {
                    text-align: right;

                    .itemStatus {
                        font-size: 16px;
                    }

                    .itemTime {
                        margin-top: 10px;
                    }
                }
            }
        }
    }
</style>